import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  const pains = [{
    icon: '📖',
    text: 'Abrís el Zaffaroni o el Rivera y no sabés por dónde empezar'
  }, {
    icon: '😰',
    text: 'El parcial es el lunes y todavía no terminaste de leer el primer tema'
  }, {
    icon: '🤯',
    text: 'El profesor pregunta algo en clase y te quedás en blanco aunque leíste'
  }, {
    icon: '😶',
    text: 'En el final oral se te va todo de la cabeza justo cuando más lo necesitás'
  }, {
    icon: '📂',
    text: 'Tenés apuntes de 15 fuentes distintas que no se conectan entre sí'
  }, {
    icon: '😴',
    text: 'Estudiaste 6 horas y al otro día no recordás casi nada'
  }, {
    icon: '🔄',
    text: 'Recursaste una materia y no sabés bien qué cambiar para la próxima vez'
  }];
  return <section className="py-14 px-4 max-w-4xl mx-auto pt-[5px] pb-[5px] space-y-[0px]" data-id="element-202">
      <FadeIn data-id="element-203">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-204">
          ¿Cuántas noches más vas a quedarte estudiando sin entender nada?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 text-center mb-10 space-y-4 max-w-3xl mx-auto" data-id="element-205">
          <p data-id="element-206">
            Elegiste Derecho porque querés cambiar algo. Porque el derecho te
            apasiona. Porque te imaginás defendiendo causas reales, argumentando
            con precisión, construyendo una carrera que valga la pena.
          </p>
          <p data-id="element-207">
            Pero nadie te dijo que el primer año iba a ser así. Nadie te
            advirtió que los libros de la bibliografía tienen 600 páginas y el
            parcial es en 10 días. Que el profesor da por sabido lo que vos
            nunca viste. Que el lenguaje jurídico parece otro idioma. Que todos
            en el aula parecen entender menos vos.
          </p>
          <p className="font-bold text-white text-2xl mt-8" data-id="element-208">
            No es falta de capacidad.{' '}
            <span className="text-red-400" data-id="element-209">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-210">
        <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-211">
          <p className="text-xl font-bold text-gray-200 mb-6" data-id="element-212">
            Lo que vive el 80% de los ingresantes a Abogacía:
          </p>
          <ul className="space-y-6" data-id="element-213">
            {pains.map((pain, index) => <li key={index} className="flex gap-4 items-start" data-id="element-214">
                <span className="text-2xl shrink-0 mt-0.5" data-id="element-215">{pain.icon}</span>
                <span className="text-gray-300 text-lg" data-id="element-216">{pain.text}</span>
              </li>)}
          </ul>
          <p className="text-center text-gray-400 mt-8 font-medium" data-id="element-217">
            Fin de cuatrimestre agotado. El año siguiente, el mismo ciclo.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-218">
        <div className="text-center mt-14" data-id="element-219">
          <h3 className="text-3xl md:text-4xl font-bold text-amber-400" data-id="element-220">
            ¿Y si este fuera el último parcial que afrontaste sin sistema?
          </h3>
        </div>
      </FadeIn>
    </section>;
}